import { styled } from 'goober';

export const Wrapper = styled('div')<{ disabled?: boolean }>`
    position: relative;
    display: flex;
    width: 100%;
    border-radius: 12px;
    align-items: center;
    gap: 8px;
    ${({ disabled }) => disabled && 'opacity: 0.5'};
`;

export const TextWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    flex-grow: 1;
`;

export const IconWrapper = styled('div')`
    display: block;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
`;
